// extracted by mini-css-extract-plugin
module.exports = {"editor":"editorStyles_editor__3sTck","headlineButtonWrapper":"editorStyles_headlineButtonWrapper__2Lfem","headlineButton":"editorStyles_headlineButton__1jkH3"};